module.exports = __webpack_public_path__ + "static/media/best_dish_zone.83373514.webp";